export default ['6px', '12px', '24px', '50%', '100%']
